const { fetch: originalFetch } = window;

window.fetch = async (...args) => {
  // Helper function to send a request to the backend to store the 'Basket Reference'
  // attribute alongside the cart contents, and then update the cart with the new attribute.
  // This runs in the background and does not block the cart response being returned to the caller.
  const storeBasketReference = async (basket) => {
    try {
      const storeBasketReferenceResponse = await originalFetch('/apps/basket-reference/upsert-basket-reference', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          basket,
          metadata: {
            store: window.Shopify.shop,
          },
        }),
      });

      if (storeBasketReferenceResponse.ok) {
        const { basketReference } = await storeBasketReferenceResponse.json();

        // Fire and forget — sections are not needed here since the cart UI has
        // already been updated from the original cart response
        originalFetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              'Basket Reference': basketReference,
            },
          }),
        });
      }
    } catch (e) {
      // Basket reference update is non-critical; swallow errors silently
    }
  };

  // Destructure the arguments we require from the original fetch call
  let [resource, options] = args;

  // Intercept any POST requests to Shopify's Ajax API
  if (
    resource.startsWith('/cart')
    && (options?.method?.toUpperCase() === 'POST')
  ) {
    // Perform the original fetch operation
    const response = await originalFetch(...args);

    // If the request failed, return the response as is
    if (!response.ok) {
      return response;
    }

    // Trigger the basket reference update in the background so the caller
    // receives the cart response immediately without waiting for the upsert chain.
    if (resource.startsWith('/cart/add')) {
      // Cart add doesn't return the full cart, so fetch it separately in the background
      originalFetch('/cart.js')
        .then((r) => r.ok ? r.json() : null)
        .then((cart) => cart && storeBasketReference(cart))
        .catch(() => {});
    } else {
      // All other cart operations return the full cart — clone the response so
      // we can read the body here without consuming it for the caller
      response.clone().json()
        .then((cart) => storeBasketReference(cart))
        .catch(() => {});
    }

    return response;

  // Fallback to original fetch for all other requests
  } else {
    return originalFetch(...args);
  }
};
